export default __webpack_public_path__ + "media/events-art-2.308b0a04.svg";